import './rich-text.scss'
import type { FC } from 'react'

export interface RichTextProps {
    text: string
}

export const RichText: FC<RichTextProps> = ({ text }) => (
    <div className="rich-text" dangerouslySetInnerHTML={{ __html: text }} />
)
